import Axios, { AxiosRequestConfig } from 'axios';
import { getBffBaseUrl } from '../helper';
import { aBffError } from './bffError';

/**
 * Nucleo HTTP compartido de los clientes del BFF (auto/moto, landings).
 * - Base URL: `config.bff_url` (react_config.json, via getBffBaseUrl).
 * - Cualquier falla sale como `BffError` (envelope `{error:{code,...}}`).
 * - JSON por defecto; con `FormData` no fuerza content-type (el navegador pone el boundary).
 */

export const urlDeBff = async (path: string): Promise<string> => (await getBffBaseUrl()) + path;

/** Query string con los params definidos (descarta undefined/null/""). */
export const aQueryString = (params?: Record<string, string | number | boolean | undefined | null>): string => {
  if (!params) return '';
  const partes = Object.entries(params)
    .filter(([, valor]) => valor !== undefined && valor !== null && valor !== '')
    .map(([clave, valor]) => `${encodeURIComponent(clave)}=${encodeURIComponent(String(valor))}`);
  return partes.length ? `?${partes.join('&')}` : '';
};

export const ejecutarEnBff = async <T>(config: AxiosRequestConfig & { url: string }): Promise<T> => {
  const porDefecto = config.data instanceof FormData ? {} : { 'content-type': 'application/json' };
  try {
    const respuesta = await Axios.request<T>({
      ...config,
      headers: { ...porDefecto, ...(config.headers || {}) },
    });
    return respuesta.data;
  } catch (error) {
    throw aBffError(error);
  }
};
